interface Publication {
    title: string;
    venue: string;
    coAuthors: string;
    summary: string;
    href: string;
}

const publications: Publication[] = [
    {
        title:
            "Entwicklung und Implementierung einer GitOps-gesteuerten, Multi-Tenant-fähigen DevSecOps Kubernetes-Plattform für die Cloud-basierte Softwareentwicklung in einer Hybrid-Cloud-Umgebung",
        venue: "IT-Innovationen, Band 33 · SoSe 2024 · Hochschule Esslingen",
        coAuthors: "mit Mirko Sonntag · Praxispartner: IT-Designers GmbH",
        summary:
            "Entwurf und Implementierung eines mandantenfähigen DevSecOps-Frameworks für Remote Development. Aufbau einer Self-Service-Plattform mit Kamaji, Capsule, Flux und ArgoCD auf Talos-Linux-Kubernetes-Clustern, ergänzt um eine Go-CLI für gängige DevOps-Aufgaben.",
        href: "https://www.hs-esslingen.de/fileadmin/media/Fakultaeten/it/SERVICE/IT-Innovationen/IT-Innovationen_Band33_SoSe24.pdf#page=71",
    },
    {
        title:
            "Explorative, deskriptive und prädiktive Analyse von Strommarktdaten mittels Data Engineering- und Data Science-Methoden mit Python und R",
        venue: "IT-Innovationen, Band 30 · WS 2022/23 · Hochschule Esslingen",
        coAuthors: "mit Philipp Walter & Jürgen Koch · Praxispartner: IT-Designers GmbH",
        summary:
            "Aufbereitung und Analyse öffentlicher SMARD-Daten der Bundesnetzagentur in einem relationalen Datenmodell. Eigenes Data-Engineering-Tool in Python für Ingestion und Cleaning, anschließend deskriptive und prädiktive Analysen des deutschen Strommarkts.",
        href: "https://www.hs-esslingen.de/fileadmin/media/Fakultaeten/it/SERVICE/IT-Innovationen/IT-Innovationen-Band30_WS2223.pdf#page=60",
    },
];

export default function Publications() {
    return (
        <section id="publications" className="card">
            <h2 className="card__title">Veröffentlichungen</h2>
            <ul className="publications">
                {publications.map((pub) => (
                    <li key={pub.href} className="publication">
                        <h3 className="publication__title">{pub.title}</h3>
                        <p className="publication__venue">{pub.venue}</p>
                        <p className="publication__authors">{pub.coAuthors}</p>
                        <p className="publication__summary">{pub.summary}</p>
                        <a
                            className="publication__link"
                            href={pub.href}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Zur Veröffentlichung in IT-Innovationen
                            <svg
                                className="publication__link-icon"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <path d="M14 4h6v6" />
                                <path d="M20 4 10 14" />
                                <path d="M19 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6" />
                            </svg>
                        </a>
                    </li>
                ))}
            </ul>
        </section>
    );
}
